import { Trans, useTranslation } from 'react-i18next'
import { ContentLayout } from 'components/Layouts'
// import { Component } from '@cms-max/medicare-api-sdk'

import { Alert } from '@cmsgov/design-system'
import { MyInternalLink } from 'components/MyLink/MyInternalLink'
import { MyLinkClickHandler } from 'components/MyLink'
import { useEvent } from 'hooks/useEvent'

export function DownloadMyDataPage () {
  const { t } = useTranslation('downloadMyData')

  const Link1 = ({ children }: {children?: React.ReactNode}) => {
    const { fireEvent } = useEvent('downloadMyData')
    const handleClick: MyLinkClickHandler = (params) => fireEvent('downloadmydata_interimpage__claims_click', params)
    return (
      <MyInternalLink to="/claims" onClick={handleClick}>{children}</MyInternalLink>
    )
  }

  const Link2 = ({ children }: {children?: React.ReactNode}) => {
    const { fireEvent } = useEvent('downloadMyData')
    const handleClick: MyLinkClickHandler = (params) => fireEvent('downloadmydata_interimpage__plans_click', params)
    return (
      <MyInternalLink to="/home" onClick={handleClick}>{children}</MyInternalLink>
    )
  }

  const Link3 = ({ children }: {children?: React.ReactNode}) => {
    const { fireEvent } = useEvent('downloadMyData')
    const handleClick: MyLinkClickHandler = (params) => fireEvent('downloadmydata_interimpage_ps_click', params)
    return (
      <MyInternalLink to="/preventive-services/available" onClick={handleClick}>{children}</MyInternalLink>
    )
  }

  const bullets = t('myHealthInfo.bullets', { returnObjects: true }) as string[]

  return (
    <ContentLayout
      className="ds-u-padding-bottom--7"
      heading={t('downloadMyData.heading')}
      width="wide"
      withPrintButton
      // printComponent={Component.DownloadMyData}
    >
      <div className="ds-l-container">

        <Alert heading={t('featureChanged.heading')} className='ds-u-measure--wide ds-u-margin-bottom--2'>
          <Trans t={t} i18nKey='featureChanged.content' components={{
            link1: <Link1 />,
            link2: <Link2 />,
            link3: <Link3 />
          }} />
        </Alert>

        <h2 className="ds-text-heading--lg">{t('myHealthInfo.heading')}</h2>
        <Alert variation='warn' role='alert' heading={t('featureNotAvailable.heading')} className='ds-u-measure--wide ds-u-margin-bottom--2'>
          <Trans t={t} i18nKey='featureNotAvailable.content' components={{
            link1: <Link1 />,
            link2: <Link2 />,
            link3: <Link3 />
          }} />
        </Alert>
        <div>
          <p className='ds-u-measure--wide ds-text-body--md'>{t('myHealthInfo.paragraph')}</p>
          <ul className='ds-c-list'>
            {bullets.map((content) => (
              <li key={content} className='ds-u-measure--wide'>{content}</li>
            ))}
          </ul>
        </div>
      </div>
    </ContentLayout>
  )
}

export default DownloadMyDataPage
